export type Channel = 'facebook' | 'twitter' | 'email';
export const CHANNELS: readonly Channel[] = ['facebook', 'twitter', 'email'];
